window.ihFloatSidebar = function(opts) {
  if (window.innerWidth < 941) return;
  var nav     = document.querySelector(opts.nav);
  var content = document.querySelector(opts.content);
  if (!nav || !content) return;

  var STICKY_TOP    = 24;
  var GAP           = 36;
  var navRect       = nav.getBoundingClientRect();
  var navLeft       = navRect.left;
  var navNaturalTop = navRect.top + window.scrollY;
  var navW          = nav.offsetWidth;

  nav.style.position  = 'fixed';
  nav.style.top       = navRect.top + 'px';
  nav.style.left      = navLeft + 'px';
  nav.style.width     = navW + 'px';
  nav.style.maxHeight = 'calc(100vh - ' + (STICKY_TOP + 24) + 'px)';
  if (opts.scrollNav) nav.style.overflowY = 'auto';
  nav.style.zIndex    = '10';

  content.style.marginLeft = (navW + GAP) + 'px';
  content.style.width      = 'calc(100% - ' + (navW + GAP) + 'px)';
  content.style.flexShrink = '0';

  var current = navRect.top, target = navRect.top, rafId = null;
  var bound = opts.bound ? document.querySelector(opts.bound) : null;

  function lerp(a, b, t) { return a + (b - a) * t; }

  function updateMaxHeight(topVal) {
    if (!bound) return;
    var edge = bound.getBoundingClientRect()[opts.boundEdge || 'top'];
    nav.style.maxHeight = Math.min(
      window.innerHeight - (STICKY_TOP + 24),
      Math.max(80, edge - topVal)
    ) + 'px';
  }

  function animate() {
    current = lerp(current, target, 0.09);
    if (Math.abs(current - target) < 0.2) current = target;
    nav.style.top = current + 'px';
    updateMaxHeight(current);
    if (current === target) { rafId = null; return; }
    rafId = requestAnimationFrame(animate);
  }

  function onScroll() {
    var naturalTop = navNaturalTop - window.scrollY;
    target = Math.max(STICKY_TOP, naturalTop);
    updateMaxHeight(current);
    if (current < target - 100) current = target - 100;
    if (!rafId) rafId = requestAnimationFrame(animate);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function() {
    if (window.innerWidth < 941) {
      nav.style.cssText        = '';
      content.style.marginLeft = '';
      content.style.width      = '';
      content.style.flexShrink = '';
      return;
    }
    navLeft = nav.parentNode.getBoundingClientRect().left;
    navW    = nav.offsetWidth;
    nav.style.left           = navLeft + 'px';
    nav.style.width          = navW + 'px';
    content.style.marginLeft = (navW + GAP) + 'px';
    content.style.width      = 'calc(100% - ' + (navW + GAP) + 'px)';
    onScroll();
  }, { passive: true });

  onScroll();
};
